@if (showSpinner) {
  <app-loader> </app-loader>
}


<div class="main-wrapper">
  <div class="outer-wrapper">
    <div class="inner-section-mian payrol-main-wrapper">
        <app-payroll-detail class="graph-child" [isStar]="isStar" (isStarChanged)="updateIsStar($event)"
            (yearSelected)="onYearSelected($event)"
            [data]="pieChartData"
            [isLoading]="isLoading"
            [selectedTab]="selectedTab"
            [monthlySalary]="salarySummary.monthlySalary"
            [yearlySalary]="salarySummary.yearlySalary"
            [categoriesMonthly]="salarySummary.categoriesMonthly"
            [categoriesYearly]="salarySummary.categoriesYearly"
            [salarySummary]="salarySummary"
            (typeChanged)="payrollSummary($event)"></app-payroll-detail>
        <app-payroll-info class="detail-table-child" [isStar]="isStar"  [salaries]="salaries" [isLoading]="isLoading" [userSalaryUpcoming]="userSalaryUpcoming"  [lastSalary]="lastSalary"></app-payroll-info>
       
    </div>
  </div>
</div>
  <!-- Modal -->
    <div  class="modal fade payroll-modal pl-0" id="payrollModal" tabindex="-1" role="dialog" aria-labelledby="basicModal" aria-hidden="true" data-backdrop="static" data-keyboard="false">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content payroll-modal-content"
            >
              <div class="modal-header payroll-modal-header justify-content-center">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"  (click)="gotoDashboard()">
                  <img src="../../../../assets/theme1/smal-icons/circle-black-cross.png" alt="image">
                </button>
              </div>

              <div class="modal-body payroll-modal-body text-center payroll-modal-body"
              >
                <img src="../../../../assets/theme1/lock.png" alt="image">
                <h1 class="mt-3">Unlock Your Payroll</h1>
                <p >Please enter your secure PIN below to verify your identity and gain access to your payroll records safely and confidentially.</p>
                  <form #otpForm="ngForm" id="otp-form" class="otp-form">
                  <div class="otp-container">
                  <input *ngFor="let val of otpArray; let i = index; trackBy: trackByIndex"
                          type="text"
                          maxlength="1"
                          [value]="otpArray[i]"
                          (input)="onInput($event, i)"
                          (keyup)="onKeyUp($event, i)"
                          (keypress)="allowNumbersOnly($event)"
                          class="otp-input"
                          >
                    </div>
                    <!-- <button class="payrol-view-btn" type="button" id="verify-btn" (click)="matchOtpPayrol()">Show Payroll</button> -->
                    <p class="forget-password mb-4 mt-4" (click)="gotoForgotPassword()">Forgot Password?</p>
                  </form>

                </div>

              </div>
          </div>
    </div>


<!-- forget OTP -->

    <div class="modal fade forgot-password-modal pl-0" id="forgotPasswordModal" tabindex="-1" role="dialog" aria-labelledby="forgotModal" aria-hidden="true" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content payroll-modal-content">
          <div class="modal-header payroll-modal-header justify-content-center">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeForgotPasswordModal()">
              <img src="../../../../assets/theme1/smal-icons/circle-black-cross.png" alt="image">
            </button>
          </div>

          <div class="modal-body payroll-modal-body text-center">
              <img src="../../../../assets/theme1/lock.png" alt="image">
            <h1 class="mt-3">Enter OTP</h1>
            <p>We’ve sent a 4-digit code to {{ maskEmail(user.email) }}</p>
            <p>Enter it below to verify your identity and reset your PIN.</p>

            <form #otpForm="ngForm" id="forgot-otp-form" class="otp-form">
              <div class="otp-container forget-otp-container mb-4">
                <input *ngFor="let val of forgotOtpArray; let i = index; trackBy: trackByIndex"
                      type="text"
                      maxlength="1"
                      [value]="forgotOtpArray[i]"
                      (input)="onForgotOtpInput($event, i)"
                      (keyup)="onForgotOtpKeyUp($event, i)"
                       (keypress)="allowNumbersOnly($event)"
                      class="otp-input"
                      >
              </div>

              <!-- <button class="payrol-view-btn mt-3" type="button" (click)="verifyForgotOtp()">Submit</button> -->
            </form>
          </div>
        </div>
      </div>
    </div>






    <div class="modal fade forgot-password-modal pl-0" id="newPasswordModal" tabindex="-1" role="dialog" aria-labelledby="forgotModal" aria-hidden="true" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content payroll-modal-content">
          <div class="modal-header payroll-modal-header justify-content-center">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeForgotPasswordModal()">
              <img src="../../../../assets/theme1/smal-icons/circle-black-cross.png" alt="image">
            </button>
          </div>

          <div class="modal-body payroll-modal-body text-center">
              <img src="../../../../assets/theme1/lock.png" alt="image">
            <h1 class="mt-3">Set Your New PIN</h1>
            <p>Set a new 6-digit PIN to securely access your payroll details.</p>

            <form #newPinForm="ngForm" id="new-pin-form" class="otp-form">
            <div class="otp-container new-pin-otp-container mt-3">
              <input *ngFor="let val of newPinOtpArray; let i = index; trackBy: trackByIndex"
                    type="text"
                    maxlength="1"
                    [value]="newPinOtpArray[i]"
                    (input)="onOtpInput($event, i, newPinOtpArray)"
                    (keyup)="onOtpKeyUp($event, i, newPinOtpArray)"
                    class="otp-input">
            </div>
            <button type="button" class="payrol-view-btn mt-3" (click)="verifyNewPin()">Continue</button>
          </form>
          </div>
        </div>
      </div>
    </div>



    <div class="modal fade forgot-password-modal pl-0" id="conformPasswordModal" tabindex="-1" role="dialog" aria-labelledby="forgotModal" aria-hidden="true" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content payroll-modal-content">
          <div class="modal-header payroll-modal-header justify-content-center">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeForgotPasswordModal()">
              <img src="../../../../assets/theme1/smal-icons/circle-black-cross.png" alt="image">
            </button>
          </div>

          <div class="modal-body payroll-modal-body text-center">
              <img src="../../../../assets/theme1/lock.png" alt="image">
            <h1 class="mt-3">Confirm Your New PIN</h1>
            <p>Re-enter your new 6-digit PIN to make sure it’s correct.</p>

            <form #confirmPinForm="ngForm" id="confirm-pin-form" class="otp-form">
            <div class="otp-container confirm-pin-otp-container">
              <input *ngFor="let val of confirmPinOtpArray; let i = index; trackBy: trackByIndex"
                    type="text"
                    maxlength="1"
                    [value]="confirmPinOtpArray[i]"
                    (input)="onOtpInput($event, i, confirmPinOtpArray)"
                    (keyup)="onOtpKeyUp($event, i, confirmPinOtpArray)"
                    class="otp-input">
            </div>
            <button type="button" class="payrol-view-btn mt-3"  (click)="verifyConfirmPin()">Save</button>
          </form>
          </div>
        </div>
      </div>
    </div>